import { IMultiPrintDevice } from './../../abstract/multi-print-device';
import { Component, Input, OnInit } from '@angular/core';
import { statusTypes } from '@shared/constants/status-types';
import { DevicePublisherService } from '@shared/services/publishers/device-publisher.service';
import { Observable } from 'rxjs';
import { IDeviceUploadingFileProgress } from '@shared/interfaces/device/device-uploading-file-progress';
import { multiPrintState, multiPrintStatuses } from '@shared/constants/multiprint-state';

@Component({
  selector: 'app-multiprint-device',
  templateUrl: './multiprint-device.component.html',
  styleUrls: ['./multiprint-device.component.scss']
})
export class MultiprintDeviceComponent implements OnInit {
  @Input() data!: IMultiPrintDevice;

  private _uploadId: string | undefined;
  @Input() set uploadId(value: string | undefined) {
    if (value) {
      this._uploadId = value;
      this.uploadingProgress$ = this.devicePublisherService.getDeviceUploadingProgressObservable(this.data.id, value);
    }
  }

  get uploadId(): string | undefined {
    return this._uploadId;
  }

  statusTypes = statusTypes;
  multiPrintStatuses: Readonly<any> = multiPrintStatuses;
  multiPrintState = multiPrintState;

  uploadingProgress$!: Observable<IDeviceUploadingFileProgress>;

  constructor(private devicePublisherService: DevicePublisherService) {
  }

  ngOnInit(): void {
  }

  trackByFn(index: number, item: any) {
    return item.id;
  }
}
